// Utility functions for showing messages
export const showMessage = (message, type = 'info') => {
  const event = new CustomEvent('showMessage', {
    detail: { message, type }
  });
  window.dispatchEvent(event);
};

export const showSuccess = (message) => showMessage(message, 'success');
export const showError = (message) => showMessage(message, 'error');
export const showInfo = (message) => showMessage(message, 'info');
